import React, { PureComponent } from 'react';

import strings from 'app/locales/formula';

import Intro from 'app/components/Intro';
import TheFormula from 'app/components/TheFormula';
import ContentSection from 'app/components/ContentSection';
import ListBlock from 'app/components/ListBlock';
import BarChart from 'app/components/BarChart';
import Banner from 'app/components/Banner';

import x100 from 'app/images/x100.png';

import styles from './styles.css';

class Formula extends PureComponent {
  render() {
    const {
      intro,
      copyBlockOne,
      copyBlockTwo,
      copyBlockThree,
      ListBlockOne,
      copyBlockFour,
      barCharts,
      bannerText,
    } = strings;

    return (
      <div className={styles.container}>
        <Intro {...intro} hasLightBg={true} hasMinimalPadding={true} />
        <TheFormula />
        <ContentSection {...copyBlockOne} />
        <ContentSection {...copyBlockTwo} />
        <ContentSection {...copyBlockThree} />
        <ListBlock {...ListBlockOne} />
        <ContentSection {...copyBlockFour} />
        <BarChart {...barCharts} />
        <Banner text={bannerText} />
        <div className={styles.bottomContent}>
          <div className={styles.grid}>
            <p className={styles.text}>
              When a Prick tells you his weakness...
            </p>
            <ul className={styles.list}>
              <li className={styles.listItem}>1. Believe him.</li>
              <li className={styles.listItem}>2. Multiply by 100</li>
            </ul>
            <img src={x100} alt={'x100'} className={styles.image} />
          </div>
        </div>
      </div>
    );
  }
}

export default Formula;



// WEBPACK FOOTER //
// ./src/routes/Formula/index.js